function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.992 0a.48.48 0 01.352.148.48.48 0 01.148.352.48.48 0 01-.148.352l-7 7A.48.48 0 017.992 8a.48.48 0 01-.351-.148l-7-7A.48.48 0 01.492.5.48.48 0 01.641.148.48.48 0 01.992 0a.48.48 0 01.352.148L7.992 6.79 14.641.15A.48.48 0 0114.992 0z",
  fill: "#484644"
});

function SvgDropdownDownarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDropdownDownarrow;